import { render, staticRenderFns } from "./pintuan.vue?vue&type=template&id=259a7839&scoped=true"
import script from "./pintuan.vue?vue&type=script&lang=js"
export * from "./pintuan.vue?vue&type=script&lang=js"
import style0 from "./pintuan.vue?vue&type=style&index=0&id=259a7839&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259a7839",
  null
  
)

export default component.exports